import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Waitlist from '../containers/Waitlist/Waitlist';
import Users from '../containers/Users/Users';
import UserPage from '../containers/Users/UserPage';
import Jobs from '../containers/Jobs/Jobs';
import Conversations from '../containers/Conversations/Conversations';
import Disintermediation from '../containers/Conversations/Disintermediation';
import Talents from '../containers/Talents/Talents';
import ActiveTalents from '../containers/Talents/ActiveTalents';
import Funnel from '../containers/Funnel/Funnel';
import ActiveClients from '../containers/Talents/ActiveClients';
import DataDashboard from '../containers/DataDashboard/DataDashboard';
import Auth from '../lib/Auth';
import Charges from '../containers/Charges/Charges';

class Body extends React.Component {
  render() {

    return (
      <div style={{ margin: '20px' }}>
      {
        Auth.canOnlySeeOKRs()
        ? <Switch>
          <Route exact path="/" component={DataDashboard} />
          </Switch>
        : <Switch>
            <Route exact path="/" component={Waitlist} />
            <Route exact path="/charges" component={Charges} />
            <Route exact path="/waitlist" component={Waitlist} />
            <Route exact path="/users" component={Users} />
            <Route exact path="/users/:swipecast_user_id" component={UserPage} />
            <Route exact path="/jobs" component={Jobs} />
            <Route exact path="/conversations" component={Conversations} />
            <Route exact path="/disintermediation" component={Disintermediation} />
            <Route exact path="/talent" component={Talents} />
            <Route exact path="/active_talent" component={ActiveTalents} />
            <Route exact path="/funnel" component={Funnel} />
            <Route exact path="/active_client" component={ActiveClients} />
            <Route exact path="/data_dashboard" component={DataDashboard} />
            {/* Not found goes last */}
            <Route path="*" render={props => <div>Not found</div>} />
          </Switch>
      }
      </div>
    );
  }
}

export default Body;
